import React from "react";

import Image1 from "assets/works-examples/1.jpg";
import Image2 from "assets/works-examples/2.jpg";
import Image3 from "assets/works-examples/3.jpg";
import Image4 from "assets/works-examples/4.jpg";

//Styles
import "./Squares.scss";

function Squares() {
  const quantity = 10;
  let imagesExampleData = [Image1, Image2, Image3, Image4];
  while (imagesExampleData.length < quantity) {
    imagesExampleData = [...imagesExampleData, ...imagesExampleData];
    imagesExampleData.length > 10 && (imagesExampleData.length = 10);
  }
  return (
    <section className="page-landing squares">
      <div className="squares-wrapper" style={{ "--squares-quantity": quantity }}>
        {imagesExampleData.map((image, index) => (
          <img key={index} src={image} alt={"Work example " + index} loading="lazy" />
        ))}
      </div>
    </section>
  );
}

export default Squares;
